import { render, staticRenderFns } from "./AdvPaymentReceiptCreateForm.vue?vue&type=template&id=70f84f78&scoped=true&"
import script from "./AdvPaymentReceiptCreateForm.vue?vue&type=script&lang=js&"
export * from "./AdvPaymentReceiptCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f84f78",
  null
  
)

export default component.exports